import EmailSettings from "./email-setting";
import OtherSettings from "./other-settings";
import GymTimings from "./gym-timings";
import BussinessInfo from "./business-info";
import { useGetOrganizationQuery } from "@/services/organizationApi";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useDocumentTitle } from "usehooks-ts";
import { useGetSystemSettingsQuery } from "@/services/systemConfigApi";
import { AllSystemSetting } from "@/types/system-setting/system-config";
import SRBSettings from "./srb-settings";

const MyBusiness = () => {
  useDocumentTitle("General Setting")
  const orgId =
    useSelector((state: RootState) => state.auth.userInfo?.user?.org_id) || 0;

  const { data: organizationData, refetch } = useGetOrganizationQuery(orgId as number, {
    skip: !orgId
  })

  const { data, refetch: settingsRefetch } = useGetSystemSettingsQuery({
    query: "groups=smtp_config&groups=gym_timings&groups=other_settings&groups=srb"
  })

  const { smtp_config, gym_timings, other_settings, srb } = data || {}

  return (
    <div className="space-y-2">
      <BussinessInfo organizationData={organizationData} refetch={refetch} />
      <EmailSettings setting={smtp_config} title="smtp_config" refetch={settingsRefetch} />
      <OtherSettings setting={other_settings} title="other_settings" refetch={settingsRefetch} />
      <SRBSettings setting={srb} title="srb" refetch={settingsRefetch} />
      <GymTimings setting={gym_timings} title="gym_timings" refetch={settingsRefetch} />
    </div >
  );
};

export default MyBusiness;
